import { useTranslation } from 'react-i18next';

import { createFileRoute } from '@tanstack/react-router';

import { Text } from '@optiro/ui';

import { TrackerTrendsOrchestrator } from '@/modules/Reports/Trackers';
import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const Route = createFileRoute('/app/reports/trackers/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { userData } = useAuth();
  const { t } = useTranslation('reports');

  const canView = userData?.admin || userData?.role === 'administrator';
  if (!canView) return <Text>{t('not_authorized')}</Text>;

  return <TrackerTrendsOrchestrator />;
}
